export default ({ style, className, ...props }) => props
